// import Questionnaire from './Questionnaire';

export default {
  // component: Questionnaire,
  component: load(() => import(/* webpackChunkName: "Evaluation360-Questionnaire" */ './Questionnaire')),
  priority: 99,
  permissions: ['360EvaluationMenu/QuestionMenu/QuestionnaireMenu'] , // ['QuestionnaireMenu'],
  name: app.translate('routes.home.evaluation-360.Question Questionnaire'),
  icon: 'comment-question-outline',
  drawer: true,
};
